import { Link } from "react-router-dom";
import { formatRating, formatViews } from "@/utils/format";
import type { Video } from "@/mocks/videos";

interface VideoCardProps {
  video: Video;
  index?: number;
}

export default function VideoCard({ video, index = 0 }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      data-product-shop
      className="group block cursor-pointer animate-fade-up"
      style={{ animationDelay: `${Math.min(index, 12) * 40}ms` }}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden rounded-lg bg-background-200">
        <img
          src={video.poster}
          alt={`${video.title}海报`}
          title={`${video.title} - ${video.genres.join(" ")}`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/10 to-transparent opacity-90" />

        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md text-xs font-semibold bg-accent-500 text-background-50">
          {formatRating(video.rating)}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md text-xs font-medium bg-background-50/80 text-foreground-900 backdrop-blur-sm">
          {video.typeLabel}
        </span>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="w-12 h-12 rounded-full bg-accent-500/95 flex items-center justify-center">
            <i className="ri-play-fill text-2xl text-background-50" />
          </span>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-3">
          <p className="text-xs text-foreground-600 flex items-center gap-1">
            <i className="ri-eye-line" />
            {formatViews(video.views)} 次播放
          </p>
        </div>
      </div>
      <h3 className="mt-2.5 text-sm font-medium text-foreground-950 truncate group-hover:text-accent-500 transition-colors">
        {video.title}
      </h3>
      <p className="mt-1 text-xs text-foreground-500 truncate">
        {video.year} · {video.region}
      </p>
    </Link>
  );
}